export default __webpack_public_path__ + "media/images/projects/project-life-before-birth.jpg";